/**
 * OcorrenciaTrackingResponsavel
 * @author Simpli CLI generator
 */
import {NormalizedItem, Request, Resource} from 'simpli-web-sdk'
import {OcorrenciaTrackingResponsavelCollection} from '@/model/collection/OcorrenciaTrackingResponsavelCollection'
import {Responsavel} from '@/model/resource/Responsavel'

/* TODO: review generated class */
export class OcorrenciaTrackingResponsavel extends Resource {
  idOcorrenciaTrackingResponsavelPk: number = 0

  idResponsavelFk: number | null = null
  idOcorrenciaExterna: number | null = null
  descricao: string | null = null
  ativo: boolean | null = null

  responsavel: Responsavel | null = null

  get $id() {
    return this.idOcorrenciaTrackingResponsavelPk
  }
  set $id(val) {
    this.idOcorrenciaTrackingResponsavelPk = val
  }

  get cnpj() {
    return this.responsavel?.cnpj || null
  }

  set cnpj(val) {
    if (this.responsavel === null) this.responsavel = new Responsavel()
    this.responsavel.cnpj = val
  }

  get razaoSocial() {
    return this.responsavel?.razaoSocial || null
  }

  set razaoSocial(val) {
    if (this.responsavel === null) this.responsavel = new Responsavel()
    this.responsavel.razaoSocial = val
  }

  static validateXlsxItem(item: NormalizedItem<any>) {
    if (Object.keys(item).length == 0 || item == null) return false
    if (
      !/\d/g.test(item.idOcorrenciaExterna) ||
      !item.descricao ||
      !item.cnpj ||
      !/^(0|1){1}$/g.test(item.ativo)
    ) {
      // Desse jeito é possivel eu dar o erro com o número da linha na View
      if (!/\d/g.test(item.idOcorrenciaExterna)) {
        throw 'invalidIdOcorrenciaExterna'
      } else if (!item.descricao) {
        throw 'invalidDescricao'
      } else if (!item.cnpj) {
        throw 'invalidCnpj'
      } else if (!/^(0|1){1}$/g.test(item.ativo)) {
        // O regex ^(0|1){1}$ só aceita 1 caracter podendo ser 0 ou 1
        throw 'invalidAtivo'
      }
      return false
    }
    return true
  }

  static buildFromXlsx(
    item: NormalizedItem<any>
  ): OcorrenciaTrackingResponsavel | null {
    if (!this.validateXlsxItem(item)) return null
    const ocorrencia = new OcorrenciaTrackingResponsavel()
    ocorrencia.idOcorrenciaExterna = parseInt(item.idOcorrenciaExterna)
    ocorrencia.descricao = item.descricao as string
    ocorrencia.ativo = item.ativo == '1'
    ocorrencia.cnpj = item.cnpj.replace(/[,.()\-/]/g, '')
    return ocorrencia
  }

  /**
   * Gets a instance of a given ID of OcorrenciaTrackingResponsavel
   */
  async getOcorrenciaTrackingResponsavel(id: number) {
    return await Request.get(`/admin/ocorrencia-tracking-responsavel/${id}`)
      .name('getOcorrenciaTrackingResponsavel')
      .as(this)
      .getData()
  }

  /**
   * Deletes a instance of a given ID of OcorrenciaTrackingResponsavel
   */
  async removeOcorrenciaTrackingResponsavel() {
    return await Request.delete(
      `/admin/ocorrencia-tracking-responsavel/${this.$id}`
    )
      .name('removeOcorrenciaTrackingResponsavel')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of OcorrenciaTrackingResponsavel
   */
  static async listOcorrenciaTrackingResponsavel(params: any) {
    return await Request.get(`/admin/ocorrencia-tracking-responsavel`, {params})
      .name('listOcorrenciaTrackingResponsavel')
      .as(OcorrenciaTrackingResponsavelCollection)
      .getData()
  }

  /**
   * Persists a new instance of OcorrenciaTrackingResponsavel. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistOcorrenciaTrackingResponsavel() {
    return await Request.post(`/admin/ocorrencia-tracking-responsavel`, this)
      .name('persistOcorrenciaTrackingResponsavel')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of OcorrenciaTrackingResponsavel to use it in a CSV file
   */
  static async listCsvOcorrenciaTrackingResponsavel(params: any) {
    return await Request.get(`/admin/ocorrencia-tracking-responsavel/csv`, {
      params,
    })
      .name('listCsvOcorrenciaTrackingResponsavel')
      .as(OcorrenciaTrackingResponsavelCollection)
      .getData()
  }
}
